module.exports = __webpack_public_path__ + "media/flags/mz-44d9c5ca.svg";